module.exports = __webpack_public_path__ + "static/logo-accent-6c02a43bb133ee0d1de1850dcb4dcecf.png";